import React, { useEffect, useState } from 'react';
import $i18n from '../../../../i18n';
import { Form, Input } from '@b-design/fusion';
import { Field } from '@alifd/next';
import { history } from 'ice';
import Requests from '@/services/request';
import { FormSubmit, promisifyValidate } from '@/components/Button';
import { getQueryStringArgs } from '@/utils/url-parse';

import './index.less';

interface Props {
  changeSteps: (val: any) => void;
}
const StepB: React.FC<Props> = (props) => {
  const field = Field.useField();
  const { init, getValue, setValue, getError } = field;
  const { invitationCode, companyId, approveId, spaceId = '' } = getQueryStringArgs();
  const [approveStatus, setApproveStatus] = useState();
  const [approveAction, setApproveAction] = useState();

  useEffect(() => {
    if (companyId && companyId !== 'null') {
      Requests.get('/rest/intercnn/company/query', { companyIds: companyId }).then((res) => {
        if (res) {
          const data = res?.list[0];
          setValue('companyName', data.name);
          setValue('address', data.address);
          setValue('email', data.customerEmail);
          setValue('representative', data.principal);
          setValue('website', data.webPage);
          setValue('phonePrev', data.customerPhone.split('-')[0]);
          setValue('phone', data.customerPhone.split('-')[1]);
        }
      });
    }
  }, [companyId]);

  useEffect(() => {
    if (approveId && approveId !== 'null') {
      Requests.get('/rest/intercnn/approve/detail', { approveId }).then((res) => {
        if (res) {
          setApproveStatus(res.status);
          setApproveAction(res.approveAction);
        }
      });
    }
  }, [approveId]);

  const creatCompany = (v) => {
    const result = new Promise<any>((resolve, reject) => {
      Requests.post('/rest/intercnn/company/create', { ...v }).then((res) => {
        if (res) {
          resolve(res);
        } else {
          reject(res);
        }
      });
    });
    return result;
  };

  const updateCompany = (v) => {
    const result = new Promise<any>((resolve, reject) => {
      Requests.post('/rest/intercnn/company/update', { ...v }).then((res) => {
        if (res) {
          resolve(res);
        } else {
          reject(res);
        }
      });
    });
    return result;
  };

  const approve = (v) => {
    const result = new Promise<any>((resolve, reject) => {
      Requests.post('/rest/intercnn/space/approve', { ...v }).then((res) => {
        if (res) {
          resolve(res);
        } else {
          reject(res);
        }
      });
    });
    return result;
  };

  // todo: 提交表单
  const submitForm = async () => {
    const [errs, val] = await promisifyValidate(field);
    if (errs) return;
    const params = {
      name: val?.companyName,
      address: val?.address,
      customerEmail: val?.email,
      principal: val?.representative,
      webPage: val?.website,
      customerPhone: getValue('phonePrev') + '-' + getValue('phone'),
      spaceId,
    };
    const updateParams = {
      name: getValue('companyName'),
      address: getValue('address'),
      customerEmail: getValue('email'),
      principal: getValue('representative'),
      webPage: getValue('website'),
      customerPhone: getValue('phonePrev') + '-' + getValue('phone'),
      companyId,
    };
    if (
      companyId &&
      companyId !== 'null' &&
      approveStatus &&
      approveStatus !== 'PROCESSING' &&
      approveAction &&
      (approveAction === 'REJECT' || approveAction === 'WITHDRAW')
    ) {
      // Requests.post('/rest/intercnn/company/update', { ...updateParams }).then((res) => {
      //   if (res) {
      //     history?.push(
      //       `/settlein?invitationCode=${invitationCode}&spaceId=${spaceId}&companyId=${companyId}&step=2`,
      //     );
      //   }
      // });
      try {
        const res = await updateCompany(updateParams);
        if (res) {
          const approveRes = await approve({ spaceId });
          if (approveRes) {
            history?.push(
              `/settlein?invitationCode=${invitationCode}&spaceId=${spaceId}&companyId=${approveRes?.companyId}&approveId=${approveRes?.approveId}&step=2`,
            );
          }
        }
      } catch (error) {
        // Handle error if needed
      }
    } else if (companyId && companyId !== 'null' && (approveId === 'null' || !approveId)) {
      const res = await Requests.post('/rest/intercnn/space/approve', { spaceId });
      if (res) {
        history?.push(
          `/settlein?invitationCode=${invitationCode}&spaceId=${spaceId}&companyId=${res?.companyId}&approveId=${res?.approveId}&step=2`,
        );
      }
    } else {
      try {
        const res = await creatCompany(params);
        if (res) {
          const approveRes = await approve({ spaceId });
          if (approveRes) {
            history?.push(
              `/settlein?invitationCode=${invitationCode}&spaceId=${spaceId}&companyId=${approveRes?.companyId}&approveId=${approveRes?.approveId}&step=2`,
            );
          }
        }
      } catch (error) {
        // Handle error if needed
      }
    }
  };
  // 上一步
  const preSteps = () => {
    if (companyId) {
      history?.push(
        `/settlein?invitationCode=${invitationCode}&spaceId=${spaceId}&companyId=${companyId}&approveId=${approveId}&step=0`,
      );
    } else {
      history?.push(`/settlein?invitationCode=${invitationCode}&spaceId=${spaceId}&step=0`);
    }
  };

  const jumpStep = () => {
    history?.push(
      `/settlein?invitationCode=${invitationCode}&spaceId=${spaceId}&companyId=${companyId}&approveId=${approveId}&step=2`,
    );
  };
  return (
    <div className="spaceB-container">
      <div className="spaceB-content">
        <div className="spaceB-title">
          {$i18n.get({
            id: 'aopf.pages.miniapp.settleIn.Tell.business',
            dm: '告诉我们您的业务',
          })}
        </div>
        <div className="spaceB-descript">
          {$i18n.get({
            id: 'aopf.pages.miniapp.settleIn.business.message',
            dm: '在开发小程序之前，我们需要了解更多关于您和您的业务',
          })}
        </div>
        <div className="spaceB-form">
          <Form>
            <Form.Item
              style={{ marginBottom: '16px' }}
              name="companyName"
              label={$i18n.get({
                id: 'aopf.pages.miniapp.settleIn.Company.Name',
                dm: '公司名称',
              })}
              required
              disabled={approveStatus === 'PROCESSING'}
            >
              <Input
                placeholder={$i18n.get({
                  id: 'aopf.pages.miniapp.settleIn.Company.Name.characters',
                  dm: '请输入不超过30个字符的公司名称',
                })}
                style={{ width: '640px' }}
                {...init('companyName', {
                  initValue: '',
                  rules: {
                    maxLength: 30,
                    required: true,
                    message: $i18n.get({
                      id: 'aopf.pages.miniapp.settleIn.Company.Name.characters',
                      dm: '请输入不超过30个字符的公司名称',
                    }),
                  },
                })}
              />
              <p style={{ fontSize: 12, color: '#c82727' }}>{getError('companyName')}</p>
            </Form.Item>
            <Form.Item
              style={{ marginBottom: '16px' }}
              name="address"
              label={$i18n.get({
                id: 'aopf.pages.miniapp.settleIn.Business.Address',
                dm: '公司地址',
              })}
              required
              disabled={approveStatus === 'PROCESSING'}
            >
              <Input
                placeholder={$i18n.get({
                  id: 'aopf.pages.miniapp.settleIn.Business.Address.characters',
                  dm: '请输入不超过30个字符的公司地址',
                })}
                style={{ width: '640px' }}
                {...init('address', {
                  initValue: '',
                  rules: [
                    {
                      maxLength: 30,
                      required: true,
                      message: $i18n.get({
                        id: 'aopf.pages.miniapp.settleIn.Business.Address.characters',
                        dm: '请输入不超过30个字符的公司地址',
                      }),
                    },
                  ],
                })}
              />
              <p style={{ fontSize: 12, color: '#c82727' }}>{getError('address')}</p>
            </Form.Item>
            <Form.Item
              style={{ marginBottom: '16px' }}
              name="representative"
              label={$i18n.get({
                id: 'aopf.pages.miniapp.settleIn.Business.Representative',
                dm: '公司代表',
              })}
              required
              disabled={approveStatus === 'PROCESSING'}
            >
              <Input
                placeholder={$i18n.get({
                  id: 'aopf.pages.miniapp.settleIn.Business.Representative.characters',
                  dm: '请输入不超过30个字符的公司代表',
                })}
                style={{ width: '640px' }}
                {...init('representative', {
                  initValue: '',
                  rules: [
                    {
                      maxLength: 30,
                      required: true,
                      message: $i18n.get({
                        id: 'aopf.pages.miniapp.settleIn.Business.Representative.characters',
                        dm: '请输入不超过30个字符的公司代表',
                      }),
                    },
                  ],
                })}
              />
              <p style={{ fontSize: 12, color: '#c82727' }}>{getError('representative')}</p>
            </Form.Item>
            <Form.Item
              style={{ marginBottom: '16px' }}
              name="website"
              label={$i18n.get({
                id: 'aopf.pages.miniapp.settleIn.Website',
                dm: '网站',
              })}
              disabled={approveStatus === 'PROCESSING'}
            >
              <Input
                placeholder={$i18n.get({
                  id: 'aopf.pages.miniapp.settleIn.Website.characters',
                  dm: '如: www.example.com',
                })}
                style={{ width: '640px' }}
                {...init('website', {
                  initValue: '',
                  rules: [
                    {
                      pattern:
                        /^((https?|ftp|smtp):\/\/)?(www\.)?[a-z0-9]+(\.[a-z]+)+(\/[a-zA-Z0-9#]+\/?)*$/,
                      message: $i18n.get({
                        id: 'aopf.pages.miniapp.drawer.form.website.err.msg',
                        dm: '请输入正确的网站',
                      }),
                    },
                  ],
                })}
              />
              <p style={{ fontSize: 12, color: '#c82727' }}>{getError('website')}</p>
            </Form.Item>
            <Form.Item
              name="phone"
              label={$i18n.get({
                id: 'aopf.pages.miniapp.settleIn.Contact.Number',
                dm: '联系电话',
              })}
            >
              <Input
                placeholder="60"
                style={{ width: '100px' }}
                disabled={approveStatus === 'PROCESSING'}
                {...init('phonePrev', {
                  initValue: '',
                  rules: [
                    {
                      pattern: /^[\d]{1,4}$/,
                      message: $i18n.get({
                        id: 'aopf.pages.miniapp.drawer.form.phone.err.msg',
                        dm: '请输入正确的手机号',
                      }),
                    },
                  ],
                })}
              />
              <span style={{ display: 'inline-block', margin: '0 5px' }}>-</span>
              <Input
                placeholder={$i18n.get({
                  id: 'aopf.pages.miniapp.drawer.form.Customer.Service.Contact.Number.placeholder',
                  dm: '填写电话',
                })}
                disabled={approveStatus === 'PROCESSING'}
                style={{ width: 525 }}
                {...init('phone', {
                  initValue: '',
                  rules: [
                    {
                      pattern: /^[\d]{1,11}$/,
                      message: $i18n.get({
                        id: 'aopf.pages.miniapp.drawer.form.phone.err.msg',
                        dm: '请输入正确的手机号',
                      }),
                    },
                  ],
                })}
              />
              {getError('phone') || getError('phonePrev') ? (
                <p style={{ fontSize: 12, color: '#c82727' }}>
                  {$i18n.get({
                    id: 'aopf.pages.miniapp.drawer.form.phone.err.msg',
                    dm: '请输入正确的手机号',
                  })}
                </p>
              ) : null}
            </Form.Item>
            <Form.Item
              name="email"
              style={{ marginBottom: '16px' }}
              label={$i18n.get({
                id: 'aopf.pages.miniapp.settleIn.Email.Address',
                dm: '电子邮件地址',
              })}
              disabled={approveStatus === 'PROCESSING'}
            >
              <Input
                placeholder={$i18n.get({
                  id: 'aopf.pages.miniapp.drawer.form.Customer.Service.Contact.Email.placeholder',
                  dm: '请输入唯一的名称，长度为2~36个字符',
                })}
                style={{ width: '640px' }}
                {...init('email', {
                  initValue: '',
                  rules: [
                    {
                      pattern: /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,}$/,
                      message: $i18n.get({
                        id: 'aopf.pages.miniapp.drawer.form.Customer.Service.Contact.Email.patternMessage',
                        dm: '请输入正确的邮箱地址',
                      }),
                    },
                    {
                      maxLength: 64,
                      message: $i18n.get({
                        id: 'aopf.pages.miniapp.settleIn.Email.characters',
                        dm: '请输入不超过64个字符的邮箱',
                      }),
                    },
                  ],
                })}
              />
              <p style={{ fontSize: 12, color: '#c82727' }}>{getError('email')}</p>
            </Form.Item>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '90px' }}>
              <div onClick={preSteps} className="previousStep">
                {$i18n.get({
                  id: 'aopf.pages.miniapp.settleIn.Previous.Step',
                  dm: '上一步',
                })}
              </div>
              <Form.Item name="agree">
                {approveStatus === 'PROCESSING' ? (
                  <FormSubmit
                    type="primary"
                    onClick={jumpStep}
                    validate
                    style={{
                      height: 40,
                      textAlign: 'center',
                      borderRadius: 4,
                      fontWeight: 500,
                      fontSize: 16,
                      color: '#fff',
                    }}
                  >
                    {$i18n.get({
                      id: 'aopf.pages.miniapp.settleIn.Next.Step',
                      dm: '下一步',
                    })}
                  </FormSubmit>
                ) : (
                  <FormSubmit
                    type="primary"
                    onClick={submitForm}
                    validate
                    style={{
                      height: 40,
                      borderRadius: 4,
                      fontWeight: 500,
                      fontSize: 16,
                      color: '#fff',
                    }}
                  >
                    {$i18n.get({
                      id: 'aopf.pages.miniapp.settleIn.Submit',
                      dm: '提交',
                    })}
                  </FormSubmit>
                )}
              </Form.Item>
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default StepB;
